import WorkerApiService from "../../workerApiServices";

class DDABoletoPagamentoService extends WorkerApiService {

    constructor() {
        super('/api/ddaBoletoPagamento')
    }

    getByDateInterval(obj){
        return this.post("/searchByDateInterval", obj)
    }

    importar(obj){
        return this.post("/importar", obj)
    }

    confirmar(obj){
        return this.post("/confirmarAssociacao", obj)
    }

    desconfirmar(obj){
        return this.post("/desconfirmarAssociacao", obj)
    }

}

export default DDABoletoPagamentoService
